import Item from './src/main'

Item.install = function (Vue) {
  Vue.component(Item.name, Item)
}

export default Item
